import React, { useEffect, useState } from "react";
import Styles from "../../Styles/TraderDashboard/Trader.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Nav, Accordion } from "react-bootstrap";
import CapacityListingHeader from "../../pages/Profile/capacityListingNew/capacityListingHeader";
import NodataFound from "../../commons/Toast/noDataFound";
import capacityConsumerService from "../Services/capacityConsumer.service";
import capacityGeneratorService from "../Services/capacityGenerator.service";
import { CircularProgress } from "@mui/material";
import traderService from "../Services/trader.service";
import { useNavigate } from "react-router-dom";
import { roleSelection } from "../../store/Login/actions";
import SwitchAccountOutlinedIcon from "@mui/icons-material/SwitchAccountOutlined";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const MainDashboard = () => {
 const [active, setActive] = useState("consumer");
 const [myListingsData, setMyListingsData] = useState([]);
 const [childListingsData, setChildListingsData] = useState([]);
 const [loader, setLoader] = useState(true);
 const [Childloader, setChildLoader] = useState(true);
 const [activeTab, setActiveTab] = useState("PLACED");
 const [roleData, setRoleData] = useState();

 const acvtiveRoleId = useSelector(
  (state) => state?.sessionState?.activeRoleId
 );
 const dispatch = useDispatch();
 const navigate = useNavigate();

 const handleChangeRole = (childData,parentData) => {
  localStorage.setItem('DATA_FILTER',JSON.stringify({childId:childData?.id,parentId:parentData?.id}))
  const toSwicthRoleId = roleData?.id;
  if (acvtiveRoleId !== toSwicthRoleId) {
   roleSelection(toSwicthRoleId, navigate)(dispatch);
  }
 };
 const getCapacityListings = (myList, childList, reqBody) => {
  let service;
  if (
   (active === "consumer" && myList) ||
   (active === "generator" && childList)
  ) {
   service = capacityConsumerService.getAllConCapacityForTrader(reqBody);
  } else if (
   (active === "generator" && myList) ||
   (active === "consumer" && childList)
  ) {
   service = capacityGeneratorService.getAllGenCapacityForTrader(reqBody);
  } else {
   return;
  }

  service
   .then((response) => {
    if (response?.data?.code === 200) {
     myList && setMyListingsData(response?.data?.data);
     childList && setChildListingsData(response?.data?.data);
     setLoader(false);
     setChildLoader(false);
    }
   })
   .catch((err) => console.log("Api Call Error: ", err));
 };

 useEffect(() => {
  if (active === "consumer") {
   getCapacityListings(true, false);
  } else return;
 }, []);
 const getRoleIdToSwicthAcc = (id) => {
  traderService
   .getRoleIdForCapacity(active?.toUpperCase(), id)
   .then((response) => {
    if (response?.data?.code === 200) {
     setRoleData(response?.data?.data);
    }
   })
   .catch((err) => console.log("Api Call Error: ", err));
 };
 const handleChangeType = (data) => {
  if (active !== data) {
   setLoader(true);
   setMyListingsData([]);
   setActive(data);
   setActiveTab("PLACED");
  } else {
   return;
  }
 };
 useEffect(() => {
  getCapacityListings(true, false);
 }, [active]);

 const handleAccordionItemClick = (value, id) => {
  setChildLoader(true);
  setChildListingsData([]);
  setActiveTab(value);
  const requestBody = {
   search: [
    {
     operation: "LIKE",
     key:
     value === "PLACED" ? (active === "generator" 
       ? "bids_capacityGenerator_id"
       : "bids_capacityConsumer_id")
       : (active === "generator" 
       ? "ownBids_againstCapacityGenerator_id"
       : "ownBids_againstCapacityConsumer_id"),
     value: id,
     value1: null,
    },
    value === "PLACED" && {
     operation: "LIKE",
     key:
      active === "generator" ? "bids_generatorStatus" : "bids_consumerStatus",
     value: value,
     value1: null,
    },
    value === "ACCEPTED" && {
     operation: "LIKE",
     key:
      active === "generator" ? "ownBids_generatorStatus" : "ownBids_consumerStatus",
     value: value,
     value1: null,
    },value === "RECEIVED" && {
      operation: "LIKE",
      key:
       active === "generator" ? "ownBids_generatorStatus" : "ownBids_consumerStatus",
      value: value,
      value1: null,
     },
   ].filter(Boolean),
  };
  getCapacityListings(false, true, requestBody);
 };

 return (
  <div className={Styles.traderMainContainer}>
   <div className={Styles.tradeHeading}>
    <div className={Styles.alterContainer}>
     <div
      onClick={() => handleChangeType("consumer")}
      className={active === "consumer" ? Styles.activeConsumerRole :''}
     >
      Consumer
     </div>
     <div
      onClick={() => handleChangeType("generator")}
      className={active === "generator" ? Styles.activeGeneratorRole :''}
     >
      Generator
     </div>
    </div>
   </div>
   <div className={Styles.listingSections}>
    {loader ? (
     <div className="text-center" style={{ marginTop: "200px" }}>
      <CircularProgress />
     </div>
    ) : (
     <Accordion defaultActiveKey="0">
      {myListingsData?.length > 0 ? (
       myListingsData?.map((data, i) => (
        <Accordion.Item key={i} eventKey={i}>
         <Accordion.Header>
          <CapacityListingHeader item={data} />
         </Accordion.Header>
         <Accordion.Body
          onEntering={() => {
           handleAccordionItemClick("PLACED", data?.id);
           getRoleIdToSwicthAcc(data?.id);
          }}
         >
          <Row className=" g-0">
           <Col sm={2} className="left-side">
            <Nav
             variant="nav"
             defaultActiveKey={activeTab}
             className="flex-column"
            >
             <Nav.Item
              onClick={() => {
               handleAccordionItemClick("PLACED", data?.id);
              }}
             >
              <Nav.Link eventKey="PLACED">Placed</Nav.Link>
             </Nav.Item>
             <Nav.Item
              onClick={() => {
               handleAccordionItemClick("RECEIVED", data?.id);
              }}
             >
              <Nav.Link eventKey="RECEIVED">Received</Nav.Link>
             </Nav.Item>
             <Nav.Item
              onClick={() => {
               handleAccordionItemClick("ACCEPTED", data?.id);
              }}
             >
              <Nav.Link eventKey="ACCEPTED">Connected</Nav.Link>
             </Nav.Item>
            </Nav>
           </Col>
           <Col sm={10} id="right-side">
            {Childloader ? (
             <div className="text-center">
              <CircularProgress />
             </div>
            ) : childListingsData?.length > 0 ? (
             childListingsData?.map((childData, i) => (
              <div key={i} className="mb-4 m-lg-2 cus-border">
               <div className="bids-name-wrap bids-name-wrap-header">
                <CapacityListingHeader item={childData} />
                <div style={{cursor:'pointer'}} onClick={()=>handleChangeRole(childData,data)}>
                 <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Switch to User Profile</Tooltip>}
                 >
                  <SwitchAccountOutlinedIcon />
                 </OverlayTrigger>
                </div>
               </div>
              </div>
             ))
            ) : (
             <NodataFound />
            )}
           </Col>
          </Row>
         </Accordion.Body>
        </Accordion.Item>
       ))
      ) : (
       <NodataFound />
      )}
     </Accordion>
    )}
   </div>
  </div>
 );
};

export default MainDashboard;
